export const tableFilterObject = (t) => ({
    label: `${t("Common:filter")}:`,
    placeholder: `${t("Common:filterPlaceholder")}...`
});